import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { get } from 'lodash';

import ResellerServices from 'services/reseller';

import { DetailReseller } from 'components/detail-reseller';
import { errHandling } from 'utils';
import { useLocation } from 'react-router-dom';

export function DetailActiveReseller() {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id') || '';

  async function getUser() {
    setLoading(true);
    try {
      const { data } = await ResellerServices.getResellerDetail(id);
      const customerDetail = get(data, 'data', []);
      setUser(customerDetail);
    } catch (error) {
      errHandling(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (id) getUser();
    // eslint-disable-next-line
  }, [id]);

  return (
    <Layout className="main-container">
      <div className="content">
        <div className="pageTitle">Detail Active Reseller</div>
        <DetailReseller
          accepted={true}
          docs={false}
          value={user}
          id={id}
          loading={loading}
        />
      </div>
    </Layout>
  );
}

export default { DetailActiveReseller };
